<template>
	<div
		v-for="item in items"
		:key="`previewFuel-${item.id}`"
		class="d-flex my-3"
	>
		<ao-groupbox custom="preview">
			<div class="d-flex">
				<span
					v-if="item.name"
					class="ao-p1 text-textBody"
				>
					{{ item.name }}
				</span>
				<v-spacer />
				<ao-icon-btn
					variant="plain"
					size="18"
					iconName="pen"
					class="mr-1"
					@click="$emit('edit', item.id)"
				/>
				<ao-icon-btn
					variant="plain"
					size="18"
					iconName="delete"
					@click="$emit('delete', item.id)"
				/>
			</div>
			<div
				class="d-flex"
				:class="{ 'flex-column': vertical }"
			>
                <ao-simple-entity-item
                    :image="item.image"
                    :icon="item.icon"
                    :geoShape="item.geoShape"
                    :title="item.title"
                    :subtitle="item.subtitle"
                />
			</div>
		</ao-groupbox>
	</div>
</template>

<script setup>
const props = defineProps({
    items: {
        type: Array, // [{id, name, image, icon, geoShape, title, subtitle}]
    },
    vertical: {
        type: Boolean,
    },
    type: {
        type: Boolean,
        default: false,
    },
    hasOwnFinanceAttribution: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['edit', 'delete'])
</script>

<style lang="scss"></style>
